import { setGroupIds } from "@progress/kendo-react-data-tools";
import { process } from '@progress/kendo-data-query';
import _ from 'lodash';
import commonApiService from "./commonApiService";
import moment from "moment";
import OutboxOutlinedIcon from '@mui/icons-material/OutboxOutlined'; // Send To OBC
import ModeOfTravelIcon from '@mui/icons-material/ModeOfTravel';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import DepotIcon from '../../common-utilities/utils/DepotIcon';
import DepotDelIcon from '../../common-utilities/utils/DepotDelIcon';
import InsertActionIcon from '../../common-utilities/utils/InsertActionIcon'; // Insert Begin/end Action
import ShareLocationIcon from '@mui/icons-material/ShareLocation';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined'; // Report icon
import TransferGoodsIcon from '../../common-utilities/utils/TransferGoodsIcon'; //  Transfer Goods
import SplitTripIcon from '../../common-utilities/utils/SplitTripIcon'; // Split Trip
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';  //- Regroup
import DeleteTripIcon from '../../common-utilities/utils/DeleteTripIcon'; // DeleteTrip
import HookoffIcon from '../../common-utilities/utils/HookoffIcon';
import HookoffDelIcon from '../../common-utilities/utils/HookoffDelIcon';
import CustomHookoffIcon from '../../common-utilities/utils/CustomHookoffIcon';
import MapIcon from '@mui/icons-material/Map';
import CalculatorIcon from '../../common-utilities/utils/CalculatorIcon';
import MoveUpIcon from "../../common-utilities/utils/MoveUpIcon";
import MoveDownIcon from "../../common-utilities/utils/MoveDownIcon";
import ChangeRoutesIcon from "../../common-utilities/utils/ChangeRoutesIcon";
import ChangeStatusIcon from "../../common-utilities/utils/ChangeStatusIcon";
import ShipmentMoveBlIcon from "../../common-utilities/utils/ShipmentMoveBlIcon";
import TableRowIcon from '../../common-utilities/utils/TableRowIcon';
import TableColumnIcon from '../../common-utilities/utils/TableColumnIcon';
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import RefreshIcon from '@mui/icons-material/Refresh';
import SplitScreen from '@mui/icons-material/Splitscreen';
import OpenWithIcon from '@mui/icons-material/OpenWith';
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
import GroupsIcon from '@mui/icons-material/Groups';
import BlockIcon from '@mui/icons-material/Block';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import SplitupIcon from "../utils/SplitupIcon";
import RegroupIcon from "../utils/RegroupIcon";
import ProcessTripsIcon from "../utils/ProcessTripsIcon";
import CreateBookingIcon from "../utils/CreateBookingIcon";
import CreateExistingBookingIcon from "../utils/CreateExistingBookingIcon";
import ViewEcmrIcon from "../utils/ViewEcmrIcon";
import CreateEcmrIcon from "../utils/CreateEcmrIcon";
import TruckAppointmentOverviewIcon from "../utils/TruckAppointmentOverviewIcon";
import TruckAppointmentIcon from "../utils/TruckAppointmentIcon";
import TruckAppointmentAddIcon from "../utils/TruckAppointmentAddIcon";
import InsertTerminalIcon from "../utils/InsertTerminalIcon";
import DeleteTerminalIcon from "../utils/DeleteTerminalIcon";
import CreateTripIcon from "../utils/CreateTripIcon";
import BatchTripCreationIcon from "../utils/BatchTripCreationIcon";
import PrintCmrIcon from "../utils/PrintCmrIcon";
import ExchangeTrailerIcon from "../utils/ExchangeTrailerIcon";
import InsertShippinglineIcon from "../utils/InsertShippinglineIcon";
import ChangesStatusTripIcon from "../utils/ChangesStatusTripIcon";
import InsertExtraActionIcon from "../utils/InsertExtraActionIcon";
import EmailTripIcon from "../utils/EmailTripIcon";
import PrintOutsourceConfirmationIcon from "../utils/PrintOutsourceConfirmationIcon";
import EmailConfirmationIcon from "../utils/EmailConfirmationIcon";
import ChangePlanDepartmentIcon from "../utils/ChangePlanDepartmentIcon";
import ChangePlanSubDepartmentIcon from "../utils/ChangePlanSubDepartmentIcon";
import PrintTripSheetIcon from "../utils/PrintTripSheetIcon";
import MoveLuIcon from "../utils/MoveLuIcon";
import SplitTrailerIcon from "../utils/SplitTrailerIcon";
import NewTrailerIcon from "../utils/NewTrailerIcon";
import FilterNoneIcon from '@mui/icons-material/FilterNone';
import BlurOnIcon from '@mui/icons-material/BlurOn';
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import HelpCenterIcon from '@mui/icons-material/HelpCenter';
import dataStorageService from "./DataStorageService";
import PartialTripIcon from "../utils/PartialTripIcon";
import DrillDownTripIcon from "../utils/DrillDownTripIcon";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import ShowObcMsgIcon from "../utils/ShowObcMsgIcon";
import CardResourcesIcon from "../utils/CardResourcesIcon";
import { CommonConst as Consts } from '../../common-utilities/enums/CommonConst.jsx';
import mapDepot from "../../../assets/images/map-depot.svg";
import mapDepotSelect from "../../../assets/images/map-depot-select.svg";
import mapLoad from "../../../assets/images/map-load.svg";
import mapLoadSelect from "../../../assets/images/map-load-select.svg";
import mapUnload from "../../../assets/images/map-unload.svg";
import mapUnloadSelect from "../../../assets/images/map-unload-select.svg";
import { guid } from '@progress/kendo-react-common';
import FourCornerIcon from "../utils/FourCornerIcon.jsx";
import SendObcMsgIcon from "../utils/SendObcMsgIcon.jsx";
import ManualModeIcon from "../utils/ManualModeIcon.jsx";
import DescriptionIcon from '@mui/icons-material/Description';
import ClearIcon from '@mui/icons-material/Clear';
import RemoveIcon from '@mui/icons-material/Remove';
import ChangeCircleOutlinedIcon from '@mui/icons-material/ChangeCircleOutlined';import LassoIcon from "../utils/LassoSelect";
import HighlightAltIcon from '@mui/icons-material/HighlightAlt';
import { RefreshOutlined } from "@mui/icons-material";
import RemoveResourceIcon from "../utils/RemoveResource";
import TripIcon from "../utils/TripIcon";
import ReactDOMServer from 'react-dom/server';
import MarkerSvgIcon from "../utils/MarkerSvgIcon";
import TruckLoadIcon from "../utils/TruckLoadIcon";
import TruckLoadDeportIcon from "../utils/TruckLoadDeportIcon";
import TruckUnLoadIcon from "../utils/TruckUnLoadIcon";
import TruckUnLoadDeportIcon from "../utils/TruckUnLoadDeportIcon";
import PickupIcon from "../utils/PickupIcon";
import DepositIcon from "../utils/DepositIcon";
import CoupleIcon from "../utils/CoupleIcon";
import UnCoupleIcon from "../utils/UnCoupleIcon";
import FerryIcon from "../utils/FerryIcon";
import FerryOfIcon from "../utils/FerryOfIcon";
import CleaningIcon from "../utils/CleaningIcon";
import BreakTimeIcon from "../utils/BreakTimeIcon";
import DriveIcon from "../utils/DriveIcon";
import PartialTripDelIcon from "../utils/PartialTripDelIcon";
import PutonIcon from "../utils/PutonIcon";
import RemoveAllResourceIcon from "../utils/RemoveAllResourceIcon";
import FuelIcon from "../utils/FuelIcon.jsx";


let apiService = commonApiService();
let dataService = dataStorageService();

function getSetDataService() {
    const planActions = [
        {key:"Send To OBC",title:"Send To OBC",btnType:"Button",onClick:"onPlanButtons('send-to obc', getSelectedValues())",disabled:"disableReportIcon",icon:<OutboxOutlinedIcon />},
        {key:"Plan On New Trip",title:"Plan New Trip",btnType:"Button",onClick:"onPlanTripButtons()",disabled:"disablePTCOIcon",icon:<ModeOfTravelIcon />},
        {key:"Contract Out",title:"Contract Out",btnType:"Button",onClick:"gridFlagVal === 'partialTrips' ? onPlanButtons('contract-out', getSelectedValues()) : onPlanButtons('contract-out', getSelectedValues(null, true))",disabled:"gridFlagVal === 'partialTrips' ? disablePTContractOutIcon : disablePTCOIcon",icon:<PendingActionsIcon />},
        {key:"Process Trips",title:"Process Trips \r\n New trips will be created based on the route guides of the selected shipment movements.",btnType:"IconButton",onClick:"onPlanButtons('process-trips', getSelectedValues(null, true))",disabled:"disablePTCOIcon",icon:<ProcessTripsIcon />},
        {key:"Create Trips",title:"Create Trips \r\n A new trip will be created for each selected shipment movement.",btnType:"IconButton",onClick:"onPlanButtons('create-trips', getSelectedValues(null, true))",disabled:"disablePTCOIcon",icon:<CreateTripIcon />},
        {key:"Depot",title:"Depot",btnType:"IconButton",onClick:"onPlanButtons('depot', getSelectedValues())",disabled:"disableCODepotHOSURMPTCSBIcons",icon:<DepotIcon />},
        {key:"Delete Depot",title:"Delete Depot",btnType:"IconButton",onClick:"onPlanButtons('delete-depot', getSelectedValues())",disabled:"disableCODepotHOSURMPTCSBIcons",icon:<DepotDelIcon />},
        {key:"Insert Begin - End Action",title:"Insert Begin / End Action",btnType:"Button",onClick:"onPlanButtons('insert-begin - end action', getSelectedValues())",disabled:"disableReportIcon",icon:<InsertActionIcon />},
        {key:"Plan On Map",title:"Plan On Map",btnType:"Button",onClick:"onPlanButtons('map')",disabled:"disableCODepotHOSURMPTCSBIcons",icon:<ShareLocationIcon />},
        {key:"Report",title:"Report",btnType:"Button",onClick:"onPlanButtons('reports', getSelectedValues())",disabled:"disableReportIcon",icon:<FactCheckOutlinedIcon />},
        {key:"Transfer Goods",title:"Transfer Goods",btnType:"Button",onClick:"onPlanButtons('transfer-goods', getSelectedValues())",disabled:"disableReportIcon",icon:<TransferGoodsIcon />},
        {key:"Split Trip",title:"Split Trip",btnType:"Button",onClick:"onPlanButtons('split-trip', getSelectedValues())",disabled:"disableReportIcon",icon:<SplitTripIcon />},
        {key:"Regroup",title:"Regroup",btnType:"Button",onClick:"onPlanButtons('regroup', getSelectedValues())",disabled:"disableReportIcon",icon:<GroupsOutlinedIcon />},
        // {key:"Delete Trip",title:"Delete Trip",btnType:"IconButton",onClick:"onPlanButtons('delete-trip', getSelectedValues())",disabled:"disableReportIcon",icon:<DeleteTripIcon />},
        {key:"Hook Off",title:"Hook Off",btnType:"IconButton",onClick:"onPlanButtons('hook-off', getSelectedValues())",disabled:"disableCODepotHOSURMPTCSBIcons",icon:<HookoffIcon />},
        {key:"Delete Hook Off",title:"Delete Hook Off",btnType:"IconButton",onClick:"onPlanButtons('delete-hook off', getSelectedValues())",disabled:"disableCODepotHOSURMPTCSBIcons",icon:<HookoffDelIcon />},
        {key:"Custom Hook Off",title:"Custom Hook Off",btnType:"IconButton",onClick:"onPlanButtons('custom-hook off', getSelectedValues())",disabled:"disableCODepotHOSURMPTCSBIcons",icon:<CustomHookoffIcon />},
        {key:"Split Up",title:"Split Up",btnType:"IconButton",onClick:"onPlanButtons('split-up', getSelectedValues())",disabled:"disableReportIcon",icon:<SplitupIcon />},
        {key:"Regroup Movement",title:"Regroup Movement",btnType:"IconButton",onClick:"onPlanButtons('regroup-movement', getSelectedValues())",disabled:"disableReportIcon",icon:<RegroupIcon />},
        {key:"Create Separate Bookings",title:"Create Separate Bookings",btnType:"IconButton",onClick:"onPlanButtons('create-separate bookings', getSelectedValues())",disabled:"disableCODepotHOSURMPTCSBIcons",icon:<CreateBookingIcon />},
        {key:"Create/Add Existing Bookings",title:"Create/Add Existing Bookings",btnType:"IconButton",onClick:"onPlanButtons('create/add-existing bookings', getSelectedValues())",disabled:"disableCODepotHOSURMPTCSBIcons",icon:<CreateExistingBookingIcon />},
        {key:"View E-CMR",title:"View E-CMR",btnType:"IconButton",onClick:"onPlanButtons('view-e-cmr', getSelectedValues())",disabled:"disableReportIcon",icon:<ViewEcmrIcon />},
        {key:"Create E-CMR",title:"Create E-CMR",btnType:"IconButton",onClick:"onPlanButtons('create-e-cmr', getSelectedValues())",disabled:"disableReportIcon",icon:<CreateEcmrIcon />},
        {key:"Print CMR",title:"Print CMR",btnType:"IconButton",onClick:"onPlanButtons('print-cmr', getSelectedValues())",disabled:"disableReportIcon",icon:<PrintCmrIcon />},
        {key:"On Hold On/Off",title:"On Hold On/Off",btnType:"IconButton",onClick:"onPlanButtons('on-hold on/off', getSelectedValues())",disabled:"disableHoldOnOffIcon",icon:<BlockIcon />},
        {key:"Truck Appointment Overview",title:"Truck Appointment Overview",btnType:"IconButton",onClick:"onPlanButtons('truck-appointment overview', getSelectedValues())",disabled:"disableReportIcon",icon:<TruckAppointmentOverviewIcon />},
        {key:"Truck Appointment New",title:"Truck Appointment New",btnType:"IconButton",onClick:"onPlanButtons('truck-appointment new', getSelectedValues())",disabled:"disableReportIcon",icon:<TruckAppointmentIcon />},
        {key:"Truck Appointment Add To",title:"Truck Appointment Add To",btnType:"IconButton",onClick:"onPlanButtons('truck-appointment add to', getSelectedValues())",disabled:"disableReportIcon",icon:<TruckAppointmentAddIcon />},
        {key:"Insert Terminal",title:"Insert Terminal",btnType:"IconButton",onClick:"onPlanButtons('insert-terminal', getSelectedValues())",disabled:"disableCODepotHOSURMPTCSBIcons",icon:<InsertTerminalIcon />},
        {key:"Delete Terminal",title:"Delete Terminal",btnType:"IconButton",onClick:"onPlanButtons('delete-terminal', getSelectedValues())",disabled:"disableCODepotHOSURMPTCSBIcons",icon:<DeleteTerminalIcon />},
        {key:"Postpone",title:"Postpone",btnType:"IconButton",onClick:"onPlanButtons('postpone', getSelectedValues())",disabled:"disableCODepotHOSURMPTCSBIcons",icon:<AccessTimeIcon />},
        {key:"Change Plan Department",title:"Change Plan Department",btnType:"IconButton",onClick:"onPlanButtons('change-plan department', getSelectedValues())",disabled:"disableCODepotHOSURMPTCSBIcons",icon:<ChangePlanDepartmentIcon />},
        {key:"Change Plan Subdepartment",title:"Change Plan Subdepartment",btnType:"IconButton",onClick:"onPlanButtons('change-plan subdepartment', getSelectedValues())",disabled:"disableCODepotHOSURMPTCSBIcons",icon:<ChangePlanSubDepartmentIcon />},
        {key:"Show On Map",title:"Show On Map",btnType:"IconButton",onClick:"onPlanButtons('show-on map', getSelectedValues())",disabled:"disableReportIcon",icon:<MapIcon />},
        {key:"Calculate",title:"Calculate",btnType:"IconButton",onClick:"onPlanButtons('calculate', getSelectedValues())",disabled:"disableReportIcon",icon:<CalculatorIcon />},   
        {key:"Batch Trip Creation",title:"Batch Trip Creation",btnType:"IconButton",onClick:"onPlanButtons('batch-trip creation', getSelectedValues())",disabled:"batchTCIcon",icon:<BatchTripCreationIcon />},
        {key:"Exchange Trailer",title:"Exchange Trailer",btnType:"IconButton",onClick:"onPlanButtons('exchange-trailer', getSelectedValues())",disabled:"disableReportIcon",icon:<ExchangeTrailerIcon />},
        {key:"New Partial Trip",title:"New Partial Trip",btnType:"IconButton",onClick:"onPlanButtons('new-partial trip', getSelectedValues())",disabled:"disableReportIcon",icon:<NewTrailerIcon />},
        {key:"Split Trailer",title:"Split Trailer",btnType:"IconButton",onClick:"onPlanButtons('split-trailer', getSelectedValues())",disabled:"disableReportIcon",icon:<SplitTrailerIcon />},
        {key:"Insert Shipping Line",title:"Insert Shipping Line",btnType:"IconButton",onClick:"onPlanButtons('insert-shipping line', getSelectedValues())",disabled:"disableReportIcon",icon:<InsertShippinglineIcon />},
        {key:"Changes Status",title:"Changes Status",btnType:"IconButton",onClick:"onPlanButtons('changes-status', getSelectedValues())",disabled:"disableCODepotHOSURMPTCSBIcons",icon:<ChangesStatusTripIcon />},
        {key:"Insert Extra Action",title:"Insert Extra Action",btnType:"IconButton",onClick:"onPlanButtons('insert-extra action', getSelectedValues())",disabled:"disableReportIcon",icon:<InsertExtraActionIcon />},
        {key:"E-mail Trip Sheet",title:"E-mail Trip Sheet",btnType:"IconButton",onClick:"onPlanButtons('e-mail-trip sheet', getSelectedValues())",disabled:"disableReportIcon",icon:<EmailTripIcon />},
        {key:"Print Outsource Confirmation",title:"Print Outsource Confirmation",btnType:"IconButton",onClick:"onPlanButtons('print-outsource confirmation', getSelectedValues())",disabled:"disableReportIcon",icon:<PrintOutsourceConfirmationIcon />},
        {key:"E-mail Outsource Confirmation",title:"E-mail Outsource Confirmation",btnType:"IconButton",onClick:"onPlanButtons('e-mail-outsource confirmation', getSelectedValues())",disabled:"disableReportIcon",icon:<EmailConfirmationIcon />},
        {key:"Move Up",title:"Move Up",btnType:"IconButton",onClick:"onPlanButtons('move-up', getSelectedValues())",disabled:"disableMoveUpIcon",icon:<MoveUpIcon />},   
        {key:"Move Down",title:"Move Down",btnType:"IconButton",onClick:"onPlanButtons('move-down', getSelectedValues())",disabled:"disableMoveDownIcon",icon:<MoveDownIcon />},   
        {key:"Move To LU",title:"Move To LU",btnType:"IconButton",onClick:"onPlanButtons('move-to lu', getSelectedValues())",disabled:"disableReportIcon",icon:<MoveLuIcon />},   
        {key:"Print Trip Sheet",title:"Print Trip Sheet",btnType:"IconButton",onClick:"onPlanButtons('print-trip sheet', getSelectedValues())",disabled:"disableReportIcon",icon:<PrintTripSheetIcon />},   
        {key:"Change Route",title:"Change Route",btnType:"IconButton",onClick:"onPlanButtons('change-route', getSelectedValues())",disabled:"disableRoutesScreenIcon",icon:<ChangeRoutesIcon />},   
        {key:"Change Status",title:"Change Status",btnType:"IconButton",onClick:"onPlanButtons('change-status', getSelectedValues())",disabled:"disableRoutesScreenIcon",icon:<ChangeStatusIcon />},   
        {key:"Set Free",title:"Set Free",btnType:"IconButton",onClick:"onPlanButtons('set-free', getSelectedValues())",disabled:"gridFlagVal === 'routes' ? disableRoutesSetFreeIcon : disableShipmentMovementScreenIcon",icon:<ShipmentMoveBlIcon />},   
        {key:"Partial Trip Card",title:"Partial Trip Card",btnType:"IconButton",onClick:"onPlanButtons('partialtrip-card', getSelectedValues())",disabled:"disableReportIcon",icon:<PartialTripIcon />},   
        {key:"Trip Card",title:"Trip Card",btnType:"IconButton",onClick:"onPlanButtons('trip-card', getSelectedValues())",disabled:"disableReportIcon",icon:<DrillDownTripIcon />},   
        {key:"Shipment Card",title:"Shipment Card",btnType:"IconButton",onClick:"onPlanButtons('shipment-card', getSelectedValues())",disabled:"disableReportIcon",icon:<LocalShippingIcon />},   ,
        {key:"All Resources",title:"All Resources",btnType:"IconButton",onClick:"onPlanButtons('all-resources', getSelectedValues())",disabled:"disableReportIcon",icon:<ManageAccountsIcon />},   
        {key:"File Card",title:"File Card",btnType:"IconButton",onClick:"onPlanButtons('file-card', getSelectedValues())",disabled:"disableReportIcon",icon:<DescriptionIcon />},   
        {key:"Show OBC Messages",title:"Show OBC Messages",btnType:"IconButton",onClick:"onPlanButtons('show-obc messages', getResourceValues())",disabled:"disableResourceIcon || (['TRAILERS', 'CONTAINERS'].includes(iconActive))",icon:<ShowObcMsgIcon />},   
        {key:"Send Message to OBC",title:"Send Message to OBC",btnType:"IconButton",onClick:"onPlanButtons('send-message to obc', getResourceValues())",disabled:"disableResourceIcon || (['TRAILERS', 'CONTAINERS','CHASSIS','VARIOUS'].includes(iconActive))",icon:<SendObcMsgIcon />},   
        {key:"Show Resource Card",title:"Show Resource Card",btnType:"IconButton",onClick:"onPlanButtons('show-resource card', getResourceValues())",disabled:"disableResourceIcon",icon:<CardResourcesIcon />},   
        {key:"Fixed",title:"Fixed",btnType:"IconButton",onClick:"onPlanButtons('fixed', getSelectedRoute())",disabled:"disableReportIcon",icon:<FourCornerIcon />},   
        {key:"Manual Mode",title:"Manual Mode",btnType:"Button",onClick:"onPlanButtons('manual-mode', getSelectedValues())",disabled:"viewType != 'Route'",icon:<ManualModeIcon />},
        {key:"Change Sequence",title:"Change Sequence",btnType:"Button",onClick:"onPlanButtons('change-sequence', getSelectedValues())",disabled:"viewType != 'Route'",icon:<ChangeCircleOutlinedIcon />},
        {key:"Delete Partial Trip",title:"Delete Partial Trip",btnType:"IconButton",onClick:"onPlanButtons('delete-partial trip', getSelectedValues())",disabled:"disableReportIcon",icon:<DeleteTripIcon />},   
        {key:"Remove From Current Resource",title:"Remove From Current Resource",btnType:"IconButton",onClick:"onPlanButtons('remove-from current resource', getSelectedValues())",disabled:"disableReportIcon",icon:<RemoveResourceIcon />},   
        // {key:"Remove From All Resources",title:"Remove From All Resources",btnType:"IconButton",onClick:"onPlanButtons('remove-from all resources', getSelectedValues())",disabled:"disableReportIcon",icon:<RemoveAllResourceIcon />},   
        {key:"RectangularSelection",title:"Rectangular Selection",btnType:"IconButton",onClick:"onPlanButtons('rectangular-selection')",disabled:"false",icon:<HighlightAltIcon />,class:"(isEnableRectSelection) ? 'icon-active' : ''"},
        {key:"LassoSelection",title:"Lasso Selection",btnType:"IconButton",onClick:"onPlanButtons('lasso-selection')",disabled:"false",icon:<LassoIcon />,class:"(isEnableLassoSelection) ? 'icon-active' : ''"},
        {key:"OptimizeRoute",title:"Optimize Route",btnType:"IconButton",onClick:"onPlanButtons('optimize-route', getSelectedValues())",disabled:"!isEnableOptimizeRoute",icon:<ChangeRoutesIcon />},   
        {key:"CalculatePartialTrip",title:"Calculate Partial Trip",btnType:"IconButton",onClick:"onPlanButtons('calculate-partial-trip', getSelectedValues())",disabled:"!isEnableCalculateIcon",icon:<CalculatorIcon />},   
        {key:"SetFree",title:"SetFree",btnType:"IconButton",onClick:"onPlanButtons('set-free', getSelectedValues())",disabled:"!isEnableSetFreeIcon",icon:<ShipmentMoveBlIcon />},   
        {key:"PlanonNewTrip",title:"Plan on New Trip",btnType:"IconButton",onClick:"onPlanButtons('planon-new-trip', getSelectedValues())",disabled:"!isEnablePlanOnNewTrip",icon:<TripIcon />},   
        {key:"RemoveFromMap",title:"Remove From Map",btnType:"IconButton",onClick:"onPlanButtons('remove-from-map', getSelectedValues())",disabled:"!isEnableRemoveTrip",icon:<DeleteTripIcon />},   
        {key:"RefreshMap",title:"Refresh Map",btnType:"IconButton",onClick:"onPlanButtons('refresh-map')",disabled:"false",icon:<RefreshOutlined />},   

    ]
    const defaultSX = { m: 0, p: 0, marginTop: .5, }
    const dataActions = [
        {key:"Filter",title:"Filter",btnType:"IconButton",onClick:"onFilterIconClick()",icon:<FilterAltIcon />,isVisible:"!data.isChild",sx:defaultSX},
        {key:"Table Rows",title:"Table Rows",btnType:"IconButton",onClick:"onFreezeIconClick(e)",icon:<TableRowIcon />,isVisible:"isItemVisible",sx:defaultSX},
        {key:"View Columns",title:"View Columns",btnType:"IconButton",onClick:"onColumnIconClick()",icon:<TableColumnIcon />,isVisible:"true",sx:defaultSX},
        {key:"Settings",title:"Settings",btnType:"IconButton",onClick:"onSettingClick()",icon:<SettingsSuggestIcon />,isVisible:"true",id:"long-button",ariaHaspopup:"true",sx:{ marginRight: 1, m: 0, p: 0, marginTop: .3, }},
        {key:"Refresh",title:"Refresh",btnType:"IconButton",onClick:"onRefreshIconClick('manualRefresh')",icon:<RefreshIcon />,isVisible:"true",sx:defaultSX},
        {key:"Split Screen",title:"Split Screen",btnType:"IconButton",onClick:"data.onSplitScreenClick(true)",icon:<SplitScreen />,isVisible:"isItemVisible",sx:defaultSX},
        {key:"New Window",title:"New Window",btnType:"IconButton",onClick:"onPopup(null)",icon:<OpenWithIcon />,isVisible:"true",sx:defaultSX},
        {key:"Delete",title:"Delete Trip",btnType:"IconButton",onClick:"",icon:<RestoreFromTrashIcon />,isVisible:"true",sx:defaultSX},
        {key:"Regroup",title:"Regroup",btnType:"IconButton",onClick:"reGroupTrip()",icon:<GroupsIcon />,isVisible:"true",sx:defaultSX},
    ]
    const customActionsIcon = [
        { icon: <HelpCenterIcon sx={{ color: 'primary' }} />, iconName: "" },
        { icon: <ManageHistoryIcon sx={{ color: 'primary' }} />, iconName: "ManageHistoryIcon" },
        { icon: <FilterNoneIcon sx={{ color: 'primary' }} />, iconName: "FilterNoneIcon" },
        { icon: <BlurOnIcon sx={{ color: 'primary' }} />, iconName: "BlurOnIcon" },
        { icon: <PrintCmrIcon sx={{ color: 'primary' }} />, iconName: "PrintCmrIcon" },
        { icon: <PendingActionsIcon sx={{ color: 'primary' }} />, iconName: "PendingActionsIcon" }
    ];

    const getActionsIcon = (iconName) => {
        const iconComponent = customActionsIcon?.find(x => x.iconName === iconName) || customActionsIcon[0];
        return iconComponent.icon;
    }
    const initialSort =
    {
        movement: [{
            field: "startDate",
            dir: "asc",
        }],
        partialTrip: [{
            field: "startingDate",
            dir: "asc",
        }],
        route: [{
            field: "sequenceNo",
            dir: "asc",
        }],
        ptmovement: [{
            field: "shipmentNo",
            dir: "asc",
        }],
        vehicle: [{
            field: "codeVehicle",
            dir: "asc",
        }],
        trailer: [{
            field: "codeTrailer",
            dir: "asc",
        }],
        driver: [{
            field: "codeDriver",
            dir: "asc",
        }],
        variousResource: [{
            field: "codeResource",
            dir: "asc",
        }],
        container: [{
            field: "codeContainer",
            dir: "asc",
        }],
        subcontractor: [{
            field: "codeSubcontractor",
            dir: "asc",
        }],
        shipmentAction: [{
            field: "sequenceNo",
            dir: "asc",
        }],
        default: [{
            field: "id",
            dir: "asc",
        }]
    };
    const initialFilter = {
        logic: "and",
        filters: [
            {
                field: "status",
                operator: "contains",
                value: '',
            }
        ],
    };
    const initialSavedViewObj = {
        partialTrips: {
            savedViews: []
        },
        routes: {
            savedViews: []
        },
        shipmentMovements: {
            savedViews: []
        },
        movements: {
            savedViews: []
        },
        trip: {
            savedViews: []
        },
        vehicleResource: {
            savedViews: []
        },
        driver: {
            savedViews: []
        },
        subContractor: {
            savedViews: []
        },
        trailer: {
            savedViews: []
        },
        depot: {
            savedViews: []
        },
        variousResources: {
            savedViews: []
        },
        agendaView : {
            savedView: []
        }
    };
    const initialSavedCheckboxes = {
        partialTrips: [],
        routes: [],
        shipmentMovements: [],
        movements: [],
        trip: [],
        vehicleResource: [],
        driver: [],
        subContractor: [],
        trailer: [],
        depot: [],
        variousResources: [],
        agendaView: []
    };
    const initialSavedDropItem = {
        partialTrips: {
            actions: []
        },
        routes: {
            actions: []
        },
        shipmentMovements: {
            actions: []
        },
        movements: {
            actions: []
        },
        trip: {
            actions: []
        },
        vehicleResource: {
            actions: []
        },
        driver: {
            actions: []
        },
        subContractor: {
            actions: []
        },
        trailer: {
            actions: []
        },
        depot: {
            actions: []
        },
        variousResources: {
            actions: []
        }
    };
    const initialSortKeyViewObj = {
        partialTrips: {
            views: []
        },
        routes: {
            views: []
        },
        shipmentMovements: {
            views: []
        },
        movements: {
            views: []
        },
        trip: {
            views: []
        },
        vehicleResource: {
            views: []
        },
        driver: {
            views: []
        },
        subContractor: {
            views: []
        },
        trailer: {
            views: []
        },
        depot: {
            views: []
        },
        variousResources: {
            views: []
        }
    };
    const initialViewsObj = {
        savedViews: [],
        sortings: [],
        columns: [],
        actions: [],
        measureFields: []
    };
    const initialSelectedColViewObj = {
        partialTrips: {
            columns: []
        },
        routes: {
            columns: []
        },
        shipmentMovements: {
            columns: []
        },
        movements: {
            columns: []
        },
        trip: {
            columns: []
        },
        vehicleResource: {
            columns: []
        },
        driver: {
            columns: []
        },
        subContractor: {
            columns: []
        },
        trailer: {
            columns: []
        },
        depot: {
            columns: []
        },
        variousResources: {
            columns: []
        }
    };
    const nonFilterableColumns = ['ActionColumn', 'instructionsExist', 'qualificationsExist','depot']
    const nonReorderableColumns = ['selected', 'ActionColumn', 'instructionsExist', 'qualificationsExist']
    const movementAggregates = [
        {
            field: "loadingLength",
            aggregate: "sum",
        },
        {
            field: "volume",
            aggregate: "sum",
        },
        {
            field: "weight",
            aggregate: "sum",
        },
        {
            field: "quantity",
            aggregate: "sum",
        },
        {
            field: "netWeight",
            aggregate: "sum",
        }
    ];
    const movementColumnList = [
        { field: "instructionsExist", title: "Info", visible: true, width: 100, locked: false, order: "asc", groupBy: false },
        { field: "qualificationsExist", title: "Qualifications", type: "Edm.Boolean", visible: true, width: 100, locked: false, order: "asc", groupBy: false },
        { field: "ActionColumn", title: "Action", visible: true, width: 80, locked: false, order: "asc", groupBy: false },
        { field: "id", title: "System ID", type: "Edm.Guid", visible: true, width: 120, locked: false, order: "asc", groupBy: false },
        { field: "shipmentNo", title: "Shipment No.", type: "Edm.Int32", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "kindofMovement", title: "Kind of Movement", type: "Edm.String", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "routeGuideCode", title: "Route Guide Code", type: "Edm.String", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "startAction", title: "Start Action", type: "Edm.String", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "customerName", title: "Customer Name", type: "Edm.String", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        // { field: 'startingDate', title: 'Start Date', visible: true, locked: false, width: 120, order: 'asc', groupBy: false, type:'string'  },
        { field: "startDate", title: "Start Date", type: "Edm.Date", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "startTime", title: "Start Time", type: "Edm.String", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        // { field: 'startingTimeTill', title: 'Start Time Till', visible: true, locked: false, width: 100, order: 'asc', groupBy: false, type:'string' },
        { field: "startTimeTill", title: "Start Time Till", type: "Edm.String", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "startAddressName", title: "Start Address Name", type: "Edm.String", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "startAddressCountry", title: "Start Address Country", type: "Edm.String", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "startAddressPostCode", title: "Start Address Post Code", type: "Edm.String", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "startAddressCity", title: "Start Address City", type: "Edm.String", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "quantity", title: "Quantity", type: "Edm.Decimal", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "weight", title: "Weight", type: "Edm.Decimal", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "volume", title: "Volume", type: "Edm.Decimal", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "loadingLength", title: "Loading Length", type: "Edm.Decimal", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "endAction", title: "End Action", type: "Edm.String", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "endDate", title: "End Date", type: "Edm.Date", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "endTime", title: "End Time", type: "Edm.String", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "endTimeTill", title: "End Time Till", type: "Edm.String", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "endAddressName", title: "End Address Name", type: "Edm.String", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "endAddressCountry", title: "End Address Country", type: "Edm.String", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "endAddressPostCode", title: "End Address Post Code", type: "Edm.String", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "endAddressCity", title: "End Address City", type: "Edm.String", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "planInfo", title: "Plan Info", type: "Edm.String", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "statusPreviousMovement", title: "Status Previous Movement", type: "Edm.String", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "delDatePreviousMovement", title: "Del. Date Previous Movement", type: "Edm.Date", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "onHold", title: "Shipment On Hold", type: "Edm.Boolean", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "transportType", title: "Transport Type", type: "Edm.String", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "department", title: "Department", type: "Edm.String", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "subdepartment", title: "Subdepartment", type: "Edm.String", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "planDepartment", title: "Plan Department", type: "Edm.String", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "planSubdepartment", title: "Plan Subdepartment", type: "Edm.String", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "serviceLevel", title: "serviceLevel", type: "Edm.String", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "fileNo", title: "File No.", type: "Edm.String", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "fileReference", title: "File Reference", type: "Edm.String", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "shipmentReference", title: "Shipment Reference", type: "Edm.String", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "loadingmargin", title: "Loading margin", type: "Edm.String", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "startReference", title: "Start Reference", type: "Edm.String", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "originMajorZone", title: "Origin Major Zone", type: "Edm.String", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "originMinorZone", title: "Origin Minor Zone", type: "Edm.String", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "endReference", title: "End Reference", type: "Edm.String", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "unloadingmargin", title: "Unloading margin", type: "Edm.String", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "destinationMajorZone", title: "Destination Major Zone", type: "Edm.String", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
        { field: "destinationMinorZone", title: "Destination Minor Zone", type: "Edm.String", visible: true, width: 170, locked: false, order: "asc", groupBy: false },
    ];
    const partialTripColumnList = [
        { field: 'id', title: 'ID', width: 60, filterable: false, visible: true, order: 'asc', groupBy: false },
        { field: 'sequence', title: 'Sequence', width: 100, visible: true, order: 'asc', groupBy: false },
        { field: 'tripNo', title: 'TripNo', width: 150, visible: true, order: 'asc', groupBy: false },
        { field: 'status', title: 'Status', width: 100, visible: true, order: 'asc', groupBy: false },
        { field: 'tripDate', title: 'Trip Date', width: 100, visible: true, order: 'asc', groupBy: false },
        { field: 'plannedDepart', title: 'Planned Depart', width: 150, visible: true, order: 'asc', groupBy: false },
        { field: 'route', title: 'Route', width: 100, visible: true, order: 'asc', groupBy: false },
        { field: 'routeGuideDescription', title: 'Route Guied Description', width: 200, visible: true, order: 'asc', groupBy: false },
        { field: 'startCountry', title: 'Start Country', width: 150, visible: true, order: 'asc', groupBy: false },
        { field: 'startCity', title: 'Start City', width: 150, visible: true, order: 'asc', groupBy: false },
        { field: 'planSub', title: 'Plan Sub', width: 100, visible: true, order: 'asc', groupBy: false },
        { field: 'vehicle', title: 'Vehicle', width: 120, visible: true, order: 'asc', groupBy: false },
        { field: 'driverId', title: 'Driver', width: 120, visible: true, order: 'asc', groupBy: false },
        { field: 'driverName', title: 'Driver Name', width: 150, visible: true, order: 'asc', groupBy: false },
        { field: 'subContractorCode', title: 'Sub Contractor Code', width: 100, visible: true, order: 'asc', groupBy: false },
        { field: 'subContractorName', title: 'Sub Contractor Name', width: 200, visible: true, order: 'asc', groupBy: false },
        { field: 'endingDate', title: 'Ending Date', width: 150, visible: true, order: 'asc', groupBy: false },
        { field: 'endTime', title: 'End Time', width: 150, visible: true, order: 'asc', groupBy: false },
        { field: 'endingX', title: 'Ending X', width: 150, visible: true, order: 'asc', groupBy: false }
    ];

    const vehicleResourceColumnList = [
        { field: 'vehicleCode', title: 'Vehicle Code', visible: true, locked: false, width: 130, order: 'asc', groupBy: false },
        { field: 'numberPlate', title: 'Number Plate', visible: true, locked: false, width: 130, order: 'asc', groupBy: false },
        { field: 'actionCode', title: 'Action Code', visible: true, locked: false, width: 100, order: 'asc', groupBy: false },
        { field: 'message', title: 'Message', visible: true, locked: false, width: 100, order: 'asc', groupBy: false },
        { field: 'alert', title: 'Alert', visible: true, locked: false, width: 100, order: 'asc', groupBy: false },
        { field: 'driverFullName', title: 'Driver Full Name', visible: true, locked: false, width: 150, order: 'asc', groupBy: false },
        { field: 'city', title: 'City', visible: true, locked: false, width: 130, order: 'asc', groupBy: false },
        { field: 'pointOfTime', title: 'Point Of Time', visible: true, locked: false, width: 130, order: 'asc', groupBy: false },
    ];

    const driverResourceColumnList = [
        { field: 'driverCode', title: 'Driver Code', width: 130 },
        { field: 'numberPlate', title: 'Number Plate', width: 130 },
        { field: 'actionCode', title: 'Action Code', width: 100 },
        { field: 'message', title: 'Message', width: 100 },
        { field: 'alert', title: 'Alert', width: 100 },
        { field: 'driverFullName', title: 'Driver Full Name', width: 150 },
        { field: 'city', title: 'City', width: 130 },
        { field: 'pointOfTime', title: 'Point Of Time', width: 130 },
    ];

    const tripColumnList = [{ field: 'id', title: 'ID', visible: true, locked: false, width: 70, filterable: false, order: 'asc', groupBy: false },
    { field: 'tripNumber', title: 'Trip Number', visible: true, locked: false, width: 130, order: 'asc', groupBy: false },
    { field: 'department', title: 'Department', visible: true, locked: false, width: 95, order: 'asc', groupBy: false },
    { field: 'exported', title: 'Exported', visible: true, locked: false, width: 150, order: 'asc', groupBy: false },
    { field: 'action', title: 'Action', visible: true, locked: false, width: 100, order: 'asc', groupBy: false },
    { field: 'countryCode', title: 'Country Code', visible: true, locked: false, width: 120, order: 'asc', groupBy: false },
    { field: 'sequence', title: 'Sequence', visible: true, locked: false, width: 100, order: 'asc', groupBy: false },
    // { field: 'routes', title: 'Routes', visible: true, locked: false, width: 100, order: 'asc', groupBy: false },
    { field: 'entityName', title: 'Entity Name', visible: true, locked: false, width: 160, order: 'asc', groupBy: false },
    { field: 'isPinned', title: 'Is Pinned', visible: true, locked: false, width: 140, order: 'asc', groupBy: false },
    { field: 'totalWeight', title: 'Total Weight', visible: true, locked: false, width: 130, order: 'asc', groupBy: false },
    { field: 'isTripCompleted', title: 'Is Trip Completed', visible: true, locked: false, width: 130, order: 'asc', groupBy: false },
    // { field: 'transformJson', title: 'Transform Json', visible: true, locked: false, width: 150, order: 'asc', groupBy: false },
    // { field: 'transactionIdPrimary', title: 'Transaction Id Primary', visible: true, locked: false, width: 160, order: 'asc', groupBy: false },
    { field: 'tripResult', title: 'Trip Result', visible: true, locked: false, width: 120, order: 'asc', groupBy: false },
    { field: 'customerEntityProcessCode', title: 'Customer Entity Process Code', visible: true, locked: false, width: 180, order: 'asc', groupBy: false },
    ];

    const routeGridColumnList = [{ field: 'id', title: 'ID', width: 60, filterable: false, visible: true, order: 'asc', groupBy: false },
    { field: 'sequence', title: 'Sequence', width: 100, visible: true, order: 'asc', groupBy: false },
    { field: 'action', title: 'Action', width: 100, visible: true, order: 'asc', groupBy: false },
    { field: 'postalCode', title: 'Postal Code', width: 100, visible: true, order: 'asc', groupBy: false },
    { field: 'country', title: 'Country', width: 100, visible: true, order: 'asc', groupBy: false },
    { field: 'addressName', title: 'Address Name', width: 150, visible: true, order: 'asc', groupBy: false },
    { field: 'location', title: 'Location', width: 100, visible: true, order: 'asc', groupBy: false },
    { field: 'startDate', title: 'Start Date', width: 100, visible: true, order: 'asc', groupBy: false },
    { field: 'startTime', title: 'Start Time', width: 100, visible: true, order: 'asc', groupBy: false },
    { field: 'statusDescription', title: 'Status Description', width: 100, visible: true, order: 'asc', groupBy: false },
    { field: 'arrivalDate', title: 'Arrival Date', width: 100, visible: true, order: 'asc', groupBy: false },
    { field: 'arrivalTime', title: 'Arrival Time', width: 100, visible: true, order: 'asc', groupBy: false },
    { field: 'departureDate', title: 'Departure Date', width: 100, visible: true, order: 'asc', groupBy: false },
    { field: 'departureTime', title: 'Departure Time', width: 100, visible: true, order: 'asc', groupBy: false }
    ];

    const smovGridColumnList = [{ field: 'id', title: 'ID', width: 60, filterable: false, visible: true, order: 'asc', groupBy: false },
    { field: 'shipmentId', title: 'Shipment Id', width: 150, visible: true, order: 'asc', groupBy: false },
    { field: 'status', title: 'Status', width: 100, visible: true, order: 'asc', groupBy: false },
    { field: 'shipmentType', title: 'Shipment Type', width: 100, visible: true, order: 'asc', groupBy: false },
    { field: 'customerName', title: 'Customer Name', width: 150, visible: true, order: 'asc', groupBy: false },
    { field: 'startAction', title: 'Start Action', width: 150, visible: true, order: 'asc', groupBy: false },
    { field: 'startDate', title: 'Start Date', width: 100, visible: true, order: 'asc', groupBy: false },
    { field: 'startTime', title: 'Start Time', width: 100, visible: true, order: 'asc', groupBy: false },
    { field: 'startAddressCity', title: 'Start City', width: 100, visible: true, order: 'asc', groupBy: false },
    { field: 'startAddressCountry', title: 'Start Country', width: 100, visible: true, order: 'asc', groupBy: false },
    { field: 'endAction', title: 'End Action', width: 150, visible: true, order: 'asc', groupBy: false },
    { field: 'endDate', title: 'End Date', width: 100, visible: true, order: 'asc', groupBy: false },
    { field: 'endTime', title: 'End Time', width: 100, visible: true, order: 'asc', groupBy: false },
    { field: 'endAddressCity', title: 'End City', width: 100, visible: true, order: 'asc', groupBy: false },
    { field: 'endAddressCountry', title: 'End Country', width: 100, visible: true, order: 'asc', groupBy: false },
    { field: 'quantity', title: 'Quantity', width: 100, visible: true, order: 'asc', groupBy: false },
    { field: 'unitOfMeasure', title: 'UOM', width: 100, visible: true, order: 'asc', groupBy: false },
    { field: 'loadingRef', title: 'Loading Ref', width: 150, visible: true, order: 'asc', groupBy: false }
    ];

    const driverColumnList = [{ field: 'id', title: 'ID', visible: true, locked: false, width: 70, filterable: false, order: 'asc', groupBy: false },
    { field: 'driverId', title: 'Driver Id', visible: true, locked: false, width: 130, order: 'asc', groupBy: false },
    { field: 'driverName', title: 'DriverName', visible: true, locked: false, width: 95, order: 'asc', groupBy: false },
    { field: 'phoneNo', title: 'PhoneNo', visible: true, locked: false, width: 150, order: 'asc', groupBy: false },
    { field: 'email', title: 'Email', visible: true, locked: false, width: 100, order: 'asc', groupBy: false },
    { field: 'city', title: 'City', visible: true, locked: false, width: 120, order: 'asc', groupBy: false },
    { field: 'country', title: 'Country', visible: true, locked: false, width: 100, order: 'asc', groupBy: false },
    { field: 'contractorId', title: 'Contractor Id', visible: true, locked: false, width: 160, order: 'asc', groupBy: false }
    ];

    const subContractorColumnList = [{ field: 'id', title: 'System ID', visible: true, locked: false, width: 70, filterable: false, order: 'asc', groupBy: false },
    { field: "searchName", title: "Search Name", visible: true, locked: false, width: 150, order: "asc", groupBy: false },
    { field: "name", title: "Name", visible: true, locked: false, width: 150, order: "asc", groupBy: false },
    { field: "address", title: "Address", visible: true, locked: false, width: 150, order: "asc", groupBy: false },
    { field: "city", title: "City", visible: true, locked: false, width: 150, order: "asc", groupBy: false },
    { field: "postCode", title: "Post Code", visible: true, locked: false, width: 150, order: "asc", groupBy: false },
    { field: "county", title: "County", visible: true, locked: false, width: 150, order: "asc", groupBy: false },
    { field: 'phoneNo', title: 'Phone No.', visible: true, locked: false, width: 150, order: 'asc', groupBy: false },
    ];
    const polylineColorData = [
        '#FF5733', // orange
        '#CD5C5C', // IndianRed
        '#B22222', // FireBrick
        '#FF69B4', // HotPink
        '#C71585', // MediumVioletRed
        '#FF8C00', // DarkOrange
        '#BDB76B', // DarkKhaki
        '#D8BFD8', // Thistle
        '#DA70D6', // Orchid
        '#9370DB', // MediumPurple
      
        '#8B008B', // DarkMagenta
        '#7B68EE', // MediumSlateBlue
        '#32CD32', // lime green
        '#9ACD32', // YellowGreen
        '#6B8E23', // OliveDrab
        '#20B2AA', // LightSeaGreen
        '#008080', // Teal
        '#4682B4', // SteelBlue
        '#5F9EA0', // CadetBlue
        '#1E90FF', // DodgerBlue
      
        '#7B68EE', // MediumSlateBlue
        '#4169E1', // RoyalBlue
        '#BC8F8F', // RosyBrown
        '#B8860B', // DarkGoldenrod
        '#A52A2A', // Brown
        '#708090', // SlateGray
        '#C9C0BB', // Pale Silver
        '#98AFC7', // Blue Gray
        '#2F539B', // Estoril Blue
        '#3090C7', // Blue Ivy
      
        '#6698FF', // Sky Blue Dress
        '#16E2F5', // Bright Turquoise
        '#66CDAA', // MediumAquaMarine (W3C)
        '#045D5D', // Dark Teal
        '#2E8B57', // SeaGreen (W3C)
        '#728C00', // Venom Green
        '#78866B', // Camouflage Green
        '#4E5B31', // Military Green
        '#667C26', // Fern Green
        '#CCFB5D', // Tea Green
      
        '#FFDB58', // Mustard Yellow
        '#C19A6B', // Camel Brown
        '#B5A642', // Brass
        '#CA762B', // Pumpkin Pie
        '#966F33', // Wood
        '#827B60', // Army Brown
        '#43302E', // Old Burgundy
        '#9E4638', // Coral Brown
        '#C36241', // Rust
        '#F67280', // Pastel Red
        '#CD5C5C', // IndianRed (W3C)
        '#7D0552', // Plum Velvet
        '#C48189'  // Pink Brown
      ];      

    const defaultOverlayLayers = [
        { name: 'Partial Trips', checked: true, for: 'Satellite' },
        { name: 'Movements', checked: true, for: 'Satellite' },
        { name: 'Route', checked: true, for: 'Satellite' },
        { name: 'Cluster', checked: false, for: 'Satellite' },
        { name: 'Backgroud', checked: true, for: 'Streets' },
        { name: 'Labels', checked: true, for: 'Streets', popup: 'A pretty CSS3 popup. <br /> Easily customizable.'},
        { name: 'Toll', checked: false, for: 'Streets' },
        { name: 'Traffic', checked: false, for: 'Streets' },
        { name: 'LEZ', checked: false, for: 'Streets' }
    ]

    const generateTrips = (result, newId) => {
        if (result.items.length > 0) {
            let rowData = result.items;
            let rightNow = new Date();
            let tripStartDate = null;
            let tripStartTime = null;
            let tripEndDate = null;
            let tripEndTime = null;
            let tripStartCountry = null;
            let tripStartCity = null;
            let route = null;
            let routeGuideDescription = null;
            let objRoutesList = [];
            let objMovementList = [];
            let routeId = 1;
            rowData.forEach(row => {
                let loadStartTime = new Date(row.startDate + " " + row.startTime);
                let loadEndTime = new Date(row.startDate + " " + row.startTime);
                loadEndTime.setHours(loadEndTime.getHours() + 1);

                let unloadEndTime = new Date(row.endDate + " " + row.endTime);
                unloadEndTime.setHours(unloadEndTime.getHours() + 1);

                if (!route) {
                    route = row.routeGuiedDescription
                    routeGuideDescription = row.routeGuiedDescription + " (" + row.startAddressCity + " )"
                }
                if (!tripStartTime) {
                    tripStartDate = row.startDate;
                    tripStartTime = loadStartTime;
                    tripStartCountry = row.startAddressCountry;
                    tripStartCity = row.startAddressCity;
                } else {
                    if (tripStartTime > loadStartTime) {
                        tripStartDate = row.startDate;
                        tripStartTime = loadStartTime;
                        tripStartCountry = row.startAddressCountry;
                        tripStartCity = row.startAddressCity;
                    }
                }
                if (!tripEndTime) {
                    tripEndDate = row.endDate;
                    tripEndTime = unloadEndTime;
                } else {
                    if (tripEndTime < unloadEndTime) {
                        tripEndDate = row.endDate;
                        tripEndTime = unloadEndTime;
                    }
                }

                let objRoute = {
                    "selected": false,
                    "id": routeId,
                    "action": row.startAction,
                    "sequence": '' + routeId + '0',
                    "postalCode": row.startAddressPostalCode,
                    "country": row.startAddressCountry,
                    "addressId": row.id.toString() + routeId.toString(),
                    "addressName": row.startAddressName,
                    "location": row.startAddressCity,
                    "startDate": row.startDate,
                    "startTime": loadStartTime.toLocaleTimeString({ hour: '2-digit', minute: '2-digit' }),
                    // "startTime": loadStartTime.toLocaleTimeString('en-US', {hour: '2-digit', minute:'2-digit'}),
                    "statusDescription": row.status,
                    "arrivalDate": row.startDate,
                    "arrivalTime": loadStartTime.toLocaleTimeString({ hour: '2-digit', minute: '2-digit' }),
                    "departureDate": row.startDate,
                    "departureTime": loadEndTime.toLocaleTimeString({ hour: '2-digit', minute: '2-digit' })
                }
                objRoutesList.push(objRoute);

                objMovementList.push({ ...row, id: routeId });

                routeId++;

            });

            rowData.forEach(row => {


                let loadEndTime = new Date(row.startDate + " " + row.startTime);
                loadEndTime.setHours(loadEndTime.getHours() + 1);

                let unloadStartTime = new Date(row.endDate + " " + row.endTime);
                let unloadEndTime = new Date(row.endDate + " " + row.endTime);
                unloadEndTime.setHours(unloadEndTime.getHours() + 1);


                let objRouteunload = {
                    "selected": false,
                    "id": routeId,
                    "action": row.endAction,
                    "sequence": '' + routeId + '0',
                    "postalCode": row.endAddressPostalCode,
                    "country": row.endAddressCountry,
                    "addressId": row.id.toString() + routeId.toString(),
                    "addressName": row.endAddressName,
                    "location": row.endAddressCity,
                    "startDate": row.endDate,
                    "startTime": unloadStartTime.toLocaleTimeString({ hour: '2-digit', minute: '2-digit' }),
                    "statusDescription": row.status,
                    "arrivalDate": row.endDate,
                    "arrivalTime": unloadStartTime.toLocaleTimeString({ hour: '2-digit', minute: '2-digit' }),
                    "departureDate": row.endDate,
                    "departureTime": unloadEndTime.toLocaleTimeString({ hour: '2-digit', minute: '2-digit' })
                }
                objRoutesList.push(objRouteunload);

                routeId++;

            });

            const objTrip = {
                "id": newId,
                "sequence": newId,
                "tripNo": "F_" + rightNow.toISOString().replace(/-/g, "").slice(2, 8) + newId + "ORS",
                "status": "Pending",
                "tripDate": tripStartDate,
                "plannedDepart": tripStartTime.toLocaleTimeString({ hour: '2-digit', minute: '2-digit' }),
                "route": route,
                "routeGuideDescription": routeGuideDescription,
                "planSub": Math.random().toString(36).slice(2, 8).toUpperCase(),
                "subDevison": null,
                "vehicle": null,
                "trailer": null,
                "driverId": null,
                "driverName": null,
                "subContractorCode": null,
                "subContractorName": null,
                "endingDate": tripEndDate,
                "endTime": tripEndTime.toLocaleTimeString({ hour: '2-digit', minute: '2-digit' }),
                "endingX": null,
                "startCountry": tripStartCountry,
                "startCity": tripStartCity,
                "routes": objRoutesList,
                "shipmentMovements": objMovementList
            }
            return objTrip
        }
    };

    const getIconType = (actionNo) => {
        const _action = actionNo.toLowerCase();
        if (_action.indexOf('depot') != -1) {
          return "depot"
        } else if (_action == "unload") {
          return "unload"
        } else {
          return "load"
        }
    }

    const extractCommonData = (element, expandItem, source, drageItemsData, type, isRoute = false, selected, dottedLine) => ({
        "id": element?.id,
        "subid": expandItem?.id,
        "source": source,
        "actionNo": isRoute ? expandItem.actionCode : expandItem.actionNo,
        "sequenceNo": expandItem.sequenceNo,
        "latitude": expandItem.latitude,
        "longitude": expandItem.longitude,
        "addressCode": isRoute ? expandItem.addresscode : expandItem.addressCode,
        "addressName": expandItem.addressName || expandItem.address,
        "addressStreet": expandItem.addressStreet || expandItem.address,
        "city": expandItem.city,
        "country": expandItem.country,
        "postCode": expandItem.postCode,
        "iconType": getIconType(isRoute ? expandItem.actionCode : expandItem.actionNo),
        "type": type,
        "selected": selected || false,
        "chassis": element?.chassis,
        "driver": element?.driver,
        "driverName": element?.driverName,
        "subcontractorCode": element?.subcontractorCode,
        "trailerCode": element?.trailerCode,
        "variousResCode": element?.variousResCode,
        "vehicleCode": element?.vehicleCode,
        "dottedLine": dottedLine,
    });

    const getMapping = (key) => {
        if(key == Consts.CHASSIS){
            return ['resourceNo', 'chassis']
        } else if(key == Consts.CONTAINERS){
            return ['resourceNo', 'driver']
        } else if(key == Consts.DRIVERS){
            return ['resourceNo', 'driver']
        } else if(key == Consts.TRAILERS){
            return ['resourceNo', 'trailerCode']
        } else if(key == Consts.VARIOUS){
            return ['resourceNo', 'variousResCode']
        } else if(key == Consts.VEHICLES){
            return ['resourceNo', 'vehicleCode']
        }
    };

    const getMembers = (members) => {
        let items = [];

        return members.map(m => {
            if (m?.items && m.items.length) {
                items = [...items, ...m.items];
            }
            return m;
        }).concat(items.length ? getMembers(items) : items).filter(x => !x?.aggregates);
    };
    const processWithGroups = (data, dataState) => {
        const groups = dataState?.group;
        if (groups) {
            groups.map((group) => (group.aggregates = movementAggregates));
        }
        // if(dataState.group !== undefined){
        //     dataState.sort = [];
        // }
        dataState.group = groups;

        const newDataState = process(data, dataState);
        setGroupIds({ data: newDataState.data, group: dataState.group });
        return newDataState;
    };
    const updateMovements = (items, movements) => {
        let temp = movements.filter(e => { return !items.map(x => x.id).includes(e.id) });
        let tempItems = JSON.parse(JSON.stringify(movements))
        tempItems.forEach(e => {
            if (items.map(x => x.id).includes(e.id)) {
                e.status = 'Planned'
            }
        })
        const newObj = [...temp, ...tempItems];
        return _.orderBy(tempItems, ['id'], ['asc'])
    };

    // Format the date as 'DD-MM-YYYY'
    const dateFormat = (date, flag, days) => {
        let dateObj = new Date(date);
        if (days > 0) {
            dateObj.setDate(dateObj.getDate() + (days - 1));
        }

        const year = dateObj.getFullYear();
        const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
        const day = dateObj.getDate().toString().padStart(2, '0');
        return `${day}-${month}-${year}`;
    };

    // date-Time formatter
    function formatDateTime(dateTimeString) {
        const dateObj = new Date(dateTimeString);
        const day = String(dateObj.getUTCDate()).padStart(2, '0');
        const month = String(dateObj.getUTCMonth() + 1).padStart(2, '0'); // Month is zero-based
        const year = dateObj.getUTCFullYear();
        const hours = String(dateObj.getUTCHours()).padStart(2, '0');
        const minutes = String(dateObj.getUTCMinutes()).padStart(2, '0');

        return `${day}-${month}-${year} ${hours}:${minutes} `;
    }

    // For left sideBar
    function tempFormat(dateTimeString) {
        const dateObj = new Date(dateTimeString);
        const year = dateObj.getFullYear();
        const month = ('0' + (dateObj.getMonth() + 1)).slice(-2);  // Months are zero-indexed
        const day = ('0' + dateObj.getDate()).slice(-2);
        return `${day}-${month}-${year} `;
    }

    //sort value
    function convertSortToStringVal(data) {
        return data?.map(item => `${item.field} ${item.dir}`).join(', ');
    }

    const setColorCodeAndDate = (arrList,gridColumnList) => {
        const dateColumns = gridColumnList?.filter(item => item.type === 'Edm.Date' || item.type === 'Edm.DateTimeOffset').map(item => item.field);

        const timeColumns = gridColumnList?.filter(x => x.field.includes('Time') && x.type === 'Edm.String').map(item => item.field);
        const enumColumns = gridColumnList?.filter(field => field.enumField).map(item => ({
            field: item.field,
            enumName: item.enumName
        }));
        const enumCaptions = dataService.getLocalStorageData('enumCaptions') ? JSON.parse(dataService.getLocalStorageData('enumCaptions')) : [];
        arrList?.forEach(e => {
            timeColumns?.forEach(column => {
                if (e[column]) {
                e[column] = moment(e[column], 'HH:mm:ss').format('HH:mm');
                }
            });

            dateColumns?.forEach(column => {
                if (new Date(e[column]).getYear() < 0) {
                    e[column] = '';
                } else {
                    e[column] = new Date(e[column])
                }
            })

            enumColumns?.forEach(column => {
                if (e[column.field]) {
                  if (enumCaptions?.find(enumColumn => enumColumn?.entityName === column?.enumName)) {
                    for (const caption of enumCaptions) {
                      if (caption?.entityName === column?.enumName && caption?.values?.length > 0 && caption?.values?.filter(value => value?.name === e[column.field]).map(x => x?.caption)?.length > 0) {
                        e[column.field] = caption?.values?.filter(value => value.name === e[column.field]).map(x => x.caption)[0];
                      }
                    }
                  }
                }
            })
        });
        return arrList;
    }

    const entityDefinitions = (odataRes,entityName) => {
        const odataMetadata = odataRes;
        const url = `${process.env.REACT_APP_COMMON_API_URL}entityDefinitions?$schemaversion=2.0&$filter=entityName eq '${entityName}'`
        let data = apiService.get(url).then(captionRes => {
            const odataCaptionMetadata = captionRes.value[0].properties;
            let tempFieldList = [];
            const filteredData = odataMetadata.children[0].children[0].children.filter(e => e.name == 'EntityType' && e.attributes['Name'] == entityName);
            const dropdownData = odataMetadata.children[0].children[0].children.filter(e => e.name == 'EnumType')
            const enumCaptions = dataService.getLocalStorageData('enumCaptions') ? JSON.parse(dataService.getLocalStorageData('enumCaptions')) : [];
            filteredData[0].children.forEach(e => {
                const newdropDownData = dropdownData.filter(elem=> e.attributes['Type'] && e.attributes['Type'].endsWith(elem.attributes['Name']))
                let newArray = [], enumName = '';
                if(newdropDownData.length > 0) {
                    
                    const entityEnumCaption = enumCaptions?.find(enumColumn => enumColumn.entityName === newdropDownData[0].attributes.Name);
                    newArray = newdropDownData[0].children.map(item => {
                        if(item.attributes.Name.replace("_x0020_"," ") == " "){
                            return {
                                name:" ",
                                value:" ",
                                caption:"All"
                            }
                        }else{
                            return {
                                name: item.attributes.Name.replace("_x0020_"," "),
                                value: item.attributes.Name.replace("_x0020_"," ") !== " " ? item.attributes.Value : " ",
                                caption: entityEnumCaption?.values?.filter(value => value?.name === item?.attributes?.Name).map(x => x?.caption)[0] ? 
                                    entityEnumCaption?.values?.filter(value => value?.name === item?.attributes?.Name).map(x => x?.caption)[0] : item?.attributes?.Name
                                }
                        }
                    });
                    enumName = newdropDownData[0]?.attributes?.Name;
                }

                if (e.name == 'Property') {
                    const languageCode = localStorage.getItem("languageCode");
                    const caption = odataCaptionMetadata.filter((elem) => elem.name === e.attributes['Name'])[0].captions.filter((elem) => elem.languageCode === parseInt(languageCode))[0]?.caption;
                    const obj = {
                        field: e.attributes['Name'],
                        title: caption ? caption : e.attributes['Name'],
                        type: e.attributes['Type'],
                        enumName: enumName,
                        enumField: enumName ? true : false,
                        dropdownData : newArray,
                        visible: true,
                        width: 100,
                        locked: false,
                        order: 'asc',
                        groupBy: false
                    }
                    tempFieldList.push(obj)
                }
            });
            return tempFieldList;
        })
        .catch(error => {
            console.log(error);
            return error
        })
        return data;
    }

    const splitTitle = (data) => {
        if (data !== null && data !== undefined && data?.title) {
          const parts = data.title.split('/');
          const index = parts.length > 2 ? parts[1] : null;
          const viewName = parts[parts.length - 1];
          return { index, viewName };
        }
        return { index: null, viewName: '' };
    };

    const apiResultChecker = (result) => {
        if (result && result?.parameters && result?.parameters[0]?.name === 'notification') {
          return true;
        }
        return false;
    }

    // use above when api return ok in response
    const apiOKResultChecker = (result) => {
        return result?.status?.toLowerCase() === 'ok';
    }

    function movementObject(actualSelectedIds, gridFlagVal = 'movements', param = null) {
        let movementObject = [];
        if (param) {
            if (gridFlagVal === 'partialTrips') {
                movementObject = param.partialtriplines;
            } else if (gridFlagVal === 'routes') {
                movementObject = param.routelines;
            } else {
                movementObject = param.movementlines;
            }
        } else {
            actualSelectedIds.forEach(item => {
                if (gridFlagVal === 'partialTrips') {
                    movementObject.push({
                        "partialTripId": item
                    });
                } else if (gridFlagVal === 'routes') {
                    movementObject.push({
                        "routeId": item
                    });
                } else {
                    movementObject.push({
                        "movementId": item
                    });
                }
            });
        }
        return movementObject;
    }

    function movementLinesAndOperationDeatilObject(movementObjects, input, gridFlagVal) {
        if (gridFlagVal === 'partialTrips') {
            return {
                partialtriplines: movementObjects,
                operationDetail: [{ operation: 1, input: input }]
            };
        } else if (gridFlagVal === 'routes') {
            return {
                routelines: movementObjects,
                operationDetail: [{ operation: 1, input: input }]
            };
        } else {
            return {
                movementlines: movementObjects,
                operationDetail: [{ operation: 1, input: input }]
            };
        }
    }

    const setWindowInitialPosition = (initialWidth, initialHeight, setPosition) => {
        const newTop = Math.max(0, (window.innerHeight - initialHeight) / 2);
        const newLeft = Math.max(0, (window.innerWidth - initialWidth) / 2);
        setPosition({
            left: newLeft,
            top: newTop,
            width: initialWidth,
            height: initialHeight,
        });
    }
    
    const onMoveWindow = (event, position, setPosition) => {
        const { clientWidth, clientHeight } = document.documentElement;
        let { width, height } = position;
      
        let newLeft = event.left;
        let newTop = event.top;
      
        if (event.left < 0) {
          newLeft = 0;
        } else if (event.left + width > clientWidth) {
          newLeft = clientWidth - width + 1;
        }
      
        if (event.top < 0) {
          newTop = 0;
        } else if (event.top + height > clientHeight) {
          newTop = clientHeight - height + 1;
        }

        if (event.width >= clientWidth) {
            width = clientWidth;
        }
      
        setPosition({
          ...position,
          width: width,
          left: newLeft,
          top: newTop,
        });
    };

    const onResizeWindow = (event, setPosition) => {
        const { clientWidth } = document.documentElement;
        let { width, left } = event;

        if (event.left + event.width >= clientWidth) {
            width = event.width;
            left = 0;
        }
        setPosition({
          left: left,
          top: event.top,
          width: width,
          height: event.height,
        });
    };

    const existingColumns = (reorderedColumns, updatedData) => {
        const result = [];
        const orderedColumns = reorderedColumns?.filter(item => item !== 'selected');
    
        orderedColumns?.forEach(field => {
          const obj = updatedData?.find(item => item.field === field);
          if (obj) {
            result.push(obj);
          }
        });
        return result;
    }

    const getUserFilterData = (entityName) => {
        const dCols = JSON.parse(localStorage.getItem("defaultColumnSetting"));
        const userData = JSON.parse(localStorage.getItem('userData'));
        let tempFilterData = []
        if(userData.planDepartment != "" && dCols[entityName]?.split("~").includes("planDepartment")) 
            tempFilterData.push({ field: 'planDepartment', value: '=' + userData.planDepartment, isLast: false, type: 'Edm.String' });
        if(userData.department != "" && dCols[entityName]?.split("~").includes("department"))
            tempFilterData.push({ field: 'department', value: '=' + userData.department, isLast: false, type: 'Edm.String' });
        if(userData.planSubdepartment != "" && dCols[entityName]?.split("~").includes("planSubdepartment"))
            tempFilterData.push({ field: 'planSubdepartment', value: '=' + userData.planSubdepartment, isLast: false, type: 'Edm.String' });
        if(userData.subdepartment != "" && dCols[entityName]?.split("~").includes("subdepartment"))
            tempFilterData.push({ field: 'subdepartment', value: '=' + userData.subdepartment, isLast: false, type: 'Edm.String' });
        return tempFilterData;
    }    
    const removeUserFilterData = (filter) => {
        const fieldsToRemove = ["planDepartment", "department", "planSubdepartment", "subdepartment"];
        const filteredData = filter.filter(item => !fieldsToRemove.includes(item.field));
        return filteredData
    }
    const formateDate = (dateInput) => {
        const dateFormatRegex = /^\d{2}-\d{2}-\d{4}$/;
        if (dateFormatRegex.test(dateInput)) {
            return moment(dateInput, "DD-MM-YYYY").set({ hour: 5, minute: 30 }) .toString();
        }
        return new Date(dateInput).toString();
    }
    const createCustomIcon = (url, zoomlevel, index, isSelected) => {
        if(!url){            
            const svgString = encodeURIComponent(ReactDOMServer.renderToString(<MarkerSvgIcon index={index} isSelected={isSelected} />));
            url = `data:image/svg+xml,${svgString}`;   
        }
        return new L.Icon({
            iconUrl: url,
            iconSize: [20 + (zoomlevel * 1.5), 21 + (zoomlevel * 1.5)],
            iconAnchor: [12, 41],
            popupAnchor: [1, -34],
            shadowSize: [21 + (zoomlevel * 1.5), 21 + (zoomlevel * 1.5)],
            className : ('custom-marker' + zoomlevel)
        });
    };
    
    const generateIconWithSelection = (action, isSelected) => {
        switch (action) {
          case Consts.LOAD:
            return isSelected ? mapLoadSelect : mapLoad;
          case Consts.UNLOAD:
            return isSelected ? mapUnloadSelect : mapUnload;
          default:
            return isSelected ? mapDepotSelect : mapDepot;
        }
    };

    const genKeyValuePair = (arrList, keyProp, valueProp) => {
        return arrList.reduce((acc, item) => {
            acc[item[keyProp]] = item[valueProp];
            return acc;
        }, {});
    };

    const routesIntersect = (p1, p2, p3, p4) => {
        const det = (p2.x - p1.x) * (p4.y - p3.y) - (p4.x - p3.x) * (p2.y - p1.y);
        if (det === 0) {
            return false;
        }
    
        const lambda = ((p4.y - p3.y) * (p4.x - p1.x) + (p3.x - p4.x) * (p4.y - p1.y)) / det;
        const gamma = ((p1.y - p2.y) * (p4.x - p1.x) + (p2.x - p1.x) * (p4.y - p1.y)) / det;
    
        return (0 < lambda && lambda < 1) && (0 < gamma && gamma < 1);
    }
    
    const replaceKey = (obj, oldKey, newKey,newFields = {}) => {
        const { [oldKey]: oldKeyValue, ...rest } = obj;
        return {
            ...rest,
            [newKey]: oldKeyValue,
            ...newFields
        };
    };

    const transformResourceData = (array) => {
        const grouped = array.reduce((acc, item) => {
            const subgroup = item.subgroup || 'default';
            if (!acc[subgroup]) {
                acc[subgroup] = {
                    id: subgroup === 'default' ? Consts.Default : subgroup,
                    name: subgroup === 'default' ? Consts.Default : subgroup,
                    eventCreation: false,
                    children: []
                };
            }
            item = replaceKey(item, 'id', 'oldId')
            item = replaceKey(item, Consts.resourceId, 'id')
            acc[subgroup].children.push(item);
            return acc;
        }, {});
    
        return Object.values(grouped);
    };

    function sortEventsByTripNo(events) {
        // Sort the events array based on the tripNo property
        events.sort((a, b) => {
            // Use localeCompare to ensure proper sorting for alphanumeric strings
            return a?.tripNo?.localeCompare(b.tripNo);
        });
        return events
    }
    const getConnectionColor = (action) => {
        switch (action) {
            case Consts.LOAD:
            case Consts.LOADDEPOT:
                return "#BDE0BC";
            case Consts.UNLOAD:
            case Consts.UNLOADDEPOT:
                return "#FFCEBB";
            case Consts.PICKUP:
            case Consts.DEPOSIT:
                return "#A0D4EA";
            case Consts.COUPLE:
            case Consts.UNCOUPLE:
                return "#DFEAA0";
            case Consts.HOOKOF:
            case Consts.HOOKON:
            case Consts.HOOK_OFF:
            case Consts.HOOK_ON:
            case Consts.FERRYON:
            case Consts.FERRYOF:
                return "#A3BCFF";
            case Consts.CLEANING:
                return "#D2D0D2";
            case Consts.BREAK:
                return "#DED1B0";
            case Consts.DRIVE:
            case Consts.DRIVEEMPTY:
                return "#CFCFF5";
            case Consts.PUT_ON:
                return "#beace5";
            case Consts.FuelIcon:
                return "#e5a87f";
            default:
                return "sandybrown";
        } 
    }
    const actionColorData = [
        { class: 'complate-trip', actionCode: Consts.LOAD, executedColor: "#BDE0BC", executingColor: "#91CC90", toBeExecutedColor: "#59AA57" },
        { class: 'complate-trip', actionCode: Consts.LOADDEPOT, executedColor: "#BDE0BC", executingColor: "#91CC90", toBeExecutedColor: "#59AA57" },
        { class: 'complate-trip', actionCode: Consts.UNLOAD, executedColor: "#FFCEBB", executingColor: "#FFB598", toBeExecutedColor: "#F39773" },
        { class: 'complate-trip', actionCode: Consts.UNLOADDEPOT, executedColor: "#FFCEBB", executingColor: "#FFB598", toBeExecutedColor: "#F39773" },
        { class: 'complate-trip', actionCode: Consts.PICKUP, executedColor: "#A0D4EA", executingColor: "#82CFF0", toBeExecutedColor: "#55BCE7" },
        { class: 'complate-trip', actionCode: Consts.DEPOSIT, executedColor: "#A0D4EA", executingColor: "#82CFF0", toBeExecutedColor: "#55BCE7" },
        { class: 'complate-trip', actionCode: Consts.COUPLE, executedColor: "#DFEAA0", executingColor: "#CCDC72", toBeExecutedColor: "#B3C839" },
        { class: 'complate-trip', actionCode: Consts.UNCOUPLE, executedColor: "#DFEAA0", executingColor: "#CCDC72", toBeExecutedColor: "#B3C839" },
        { class: 'complate-trip', actionCode: Consts.HOOKOF, executedColor: "#A3BCFF", executingColor: "#95B2FF", toBeExecutedColor: "#7A9EFC" },
        { class: 'complate-trip', actionCode: Consts.HOOKON, executedColor: "#A3BCFF", executingColor: "#95B2FF", toBeExecutedColor: "#7A9EFC" },
        { class: 'complate-trip', actionCode: Consts.HOOK_ON, executedColor: "#A3BCFF", executingColor: "#95B2FF", toBeExecutedColor: "#7A9EFC" },
        { class: 'complate-trip', actionCode: Consts.HOOK_OFF, executedColor: "#A3BCFF", executingColor: "#95B2FF", toBeExecutedColor: "#7A9EFC" },
        { class: 'complate-trip', actionCode: Consts.FERRYON, executedColor: "#A3BCFF", executingColor: "#95B2FF", toBeExecutedColor: "#7A9EFC" },
        { class: 'complate-trip', actionCode: Consts.FERRYOF, executedColor: "#A3BCFF", executingColor: "#95B2FF", toBeExecutedColor: "#7A9EFC" },
        { class: 'complate-trip', actionCode: Consts.CLEANING, executedColor: "#D2D0D2", executingColor: "#B9B3B9", toBeExecutedColor: "#ACA0AC" },
        { class: 'complate-trip', actionCode: Consts.BREAK, executedColor: "#DED1B0", executingColor: "#D2BA7C", toBeExecutedColor: "#C7A95E" },
        { class: 'complate-trip', actionCode: Consts.DRIVE, executedColor: "#CFCFF5", executingColor: "#ADADEF", toBeExecutedColor: "#8888E5" },
        { class: 'complate-trip', actionCode: Consts.DRIVEEMPTY, executedColor: "#CFCFF5", executingColor: "#ADADEF", toBeExecutedColor: "#8888E5" },
        { class: 'complate-trip', actionCode: Consts.PUT_ON, executedColor: "#beace5", executingColor: "#a288d9", toBeExecutedColor: "#8f72cc" },
        { class: 'complate-trip', actionCode: Consts.FUEL, executedColor: "#e5a87f", executingColor: "#cc804c", toBeExecutedColor: "#c15d1a" },
    ]
    const getActionColor = (data) => {
        const colorData = actionColorData.find(e => e.actionCode === data.actionCode);
        const currentTime = new Date(); // Current date time
        if (!colorData) {
            return "rgb(170 244 245)";
        } else if (data.start < currentTime && currentTime < data.end) {
            return colorData.executingColor;
        } else if (data.start > currentTime) {
            return colorData.toBeExecutedColor;
        } else {
            return colorData.executedColor;
        }
    }    
    const getActionClass = (data) => {
        const currentTime = new Date()
        if (data.start < currentTime && currentTime < data.end) {
            return 'executing' // Set executing 
        } else if (data.start > currentTime) {
            return 'to-be-executed' // Set to be executed 
        } else {
            return 'executed' // Set executed 
        }
    }
    const actionIcons = {
        [Consts.LOAD]: TruckLoadIcon,
        [Consts.LOADDEPOT]: TruckLoadDeportIcon,
        [Consts.UNLOAD]: TruckUnLoadIcon,
        [Consts.UNLOADDEPOT]: TruckUnLoadDeportIcon,
        [Consts.HOOKON]: HookoffIcon,
        [Consts.HOOK_ON]: HookoffIcon,
        [Consts.HOOKOF]: HookoffDelIcon,
        [Consts.HOOK_OFF]: HookoffDelIcon,
        [Consts.PICKUP]: PickupIcon,
        [Consts.DEPOSIT]: DepositIcon,
        [Consts.COUPLE]: CoupleIcon,
        [Consts.UNCOUPLE]: UnCoupleIcon,
        [Consts.FERRYON]: FerryIcon,
        [Consts.FERRYOF]: FerryOfIcon,
        [Consts.CLEANING]: CleaningIcon,
        [Consts.BREAK]: BreakTimeIcon,
        [Consts.DRIVE]: DriveIcon,
        [Consts.DRIVEEMPTY]: DriveIcon,
        [Consts.PUT_ON]: PutonIcon,
        [Consts.FUEL]: FuelIcon,
      };
      const getActionIcon = (action,color='#000')=>{
        const ActionIcon = actionIcons[action];
        return ActionIcon ? <ActionIcon color={color} /> : <></>
      }
    const getWindowHeight = (tempEvent) => {
        if (tempEvent.isRemark)
            return 260
        else if (tempEvent.isAgendaItem)
            return 400
        else
            return 450
    }
    const updateStyles = (selector, style) => {
        document.querySelectorAll(selector).forEach(item => {
          item.style.cssText += style;
        });
    };
    const removeCssClass = (arr, resourceId, className) => {

        arr.forEach(item => {
            if (item.resource === resourceId && item.cssClass.includes(className)) {
                item.cssClass = item.cssClass?.replace(className, '').trim();
            }
        });
        return arr
    };
    const showTimelines = ()=>{
        updateStyles('.mbsc-timeline-column.mbsc-ltr', 'border-right-style:solid !important;');
        updateStyles('.mbsc-timeline-day', 'position:relative;');
    }
    const removeTimelines = ()=>{
        updateStyles('.mbsc-timeline-column.mbsc-ltr', 'border-right-style:none !important;');
        updateStyles('.mbsc-timeline-day-border', 'position:unset;');
    }
    const findResourceById = (myResources,id) => {
        for (const category of myResources) {
            for (const resource of category.children) {
                if (resource.id === id) {
                    return resource;
                }
            }
        }
        return null; // If resource with the given ID is not found
    };
    const parseActionResponse = (data) => {        
        let planAction =  data.filter(e => e?.sourceType == Consts.isRemark || e?.sourceType == Consts.isAgendaItem)?.map(item => {
            const startDate = new Date(item?.fromDate + 'T' + item?.fromTime);
            const remarkEndDate = moment(startDate).add(1, 'hours').toDate();
            let endDate = new Date(item?.toDate + 'T' + item?.toTime) // Copy the start date            
            if(item?.sourceType == Consts.isRemark){
                endDate.setHours(startDate.getHours()); // Add 1 hour to the end date
            }            
            return {
                description: item?.description,
                isRemark: item?.sourceType == Consts.isRemark ? true : false,
                isAgendaItem: item?.sourceType == Consts.isAgendaItem ? true : false,
                resource: item?.resourceId,
                start: startDate,
                end: item?.sourceType == Consts.isRemark ? remarkEndDate : endDate,
                id: item?.id,
                agendaCodeType: item?.agendaCodeType,
                original:item,
                resize:item?.sourceType == Consts.isAgendaItem ? true : false
            }
        })
        return planAction;
    }
    const findEventById = (arr,id) => {
        return arr.filter((item) => item.routeId === id)
    }
    const calculateDuration = (startTime, endTime) => {
	    const startDate = new Date(startTime);
		const endDate = new Date(endTime);

		const diffInMilliseconds = startDate - endDate;
		const diffInHours = diffInMilliseconds / (1000 * 60 * 60);

		return diffInHours;
	}
    const convertToUTCToLocal = (dateTimeString) => {
        // const dateTimeString = `${startingDate}T${startingTime}Z`; // Z indicates UTC time
        return new Date(moment.utc(dateTimeString).local().format(process.env.REACT_APP_DATETIMEFORMAT2));
    };
    const convertToLocalToUTC = (date) => {
        return moment(date).utc().format(process.env.REACT_APP_DATETIMEFORMAT2)
    }
    const findOverlappingRecord = (argsEventStart, argsEventEnd, events) => {
        const overlappingEvents = events.filter(event => {
            const eventStart = new Date(event.start).getTime();
            const eventEnd = new Date(event.end).getTime();
            const argsStart = new Date(argsEventStart).getTime();
            const argsEnd = new Date(argsEventEnd).getTime();
    
            return (argsStart < eventEnd && argsEnd > eventStart);
        });
    
        return overlappingEvents.map(e => e.partialTripId);
    }
    const findOverlappingDummyRecord = (argsEventStart, argsEventEnd, events ,res) => {
        const overlappingEvents = events.filter(event => {
            const eventStart = new Date(event.start).getTime();
            const eventEnd = new Date(event.end).getTime();
            const argsStart = new Date(argsEventStart).getTime();
            const argsEnd = new Date(argsEventEnd).getTime();
    
            return (argsStart < eventEnd && argsEnd > eventStart && event.isdummy && event.resource == res);
        });
    
        return overlappingEvents;
    }
    const findMinMaxTimes = (ids, events) => {        
        const idSet = ids.map(item => item.id.toLowerCase());
        const filteredEvents = events.filter(e => idSet.some(x => x == e.routeId?.toLowerCase()));
        const startTimes = filteredEvents.map(e => new Date(e.start).getTime());
        const endTimes = filteredEvents.map(e => new Date(e.end).getTime());
    
        const minStartTime = new Date(Math.min(...startTimes));
        const maxEndTime = new Date(Math.max(...endTimes));
    
        return {
            minStartTime,
            maxEndTime
        };
    }
    

    const parseDate = (date,id=null,type=null) => {
        if(id?.length > 0) {
            return {
                "input": JSON.stringify({newDateTime: moment(date).format(process.env.REACT_APP_DATETIMEFORMAT2),dropOnPartialTrip:id[0]})
            }
        } else {
            return {
                "input": JSON.stringify({newDateTime: moment(date).format(process.env.REACT_APP_DATETIMEFORMAT2),selectionMode:type?.toLowerCase()})
            }
        }
    }    
    const generateConditionString = (conditions) => {
        const conditionString = conditions.map(condition => {
            const value = condition.value.replace(/[{}]/g, '');
            return `${condition.name} ${condition.condition} ${value}`;
        }).join(' or ');
        return conditionString;
    };
    
    function handleFilterData(filterString, key = null) {
        const extractValueFromFilter = (filterString, key, operator) => {
            const regex = new RegExp(`${key} ${operator} ([\\d-]+)`, 'i');
            const match = filterString.match(regex);
            return match ? match[1] : null;
        };
    
        const extractStatusFromFilter = (filterString) => {
            const regex = /status eq ['"]?([\w]+)['"]?/i;
            const match = filterString.match(regex);
            return match ? match[1] : null;
        };
    
        const calculateDaysBetween = (startDate, endDate) => {
            const date1 = new Date(startDate);
            const date2 = new Date(endDate);
    
            const timeDifference = date2 - date1;
            return Math.ceil(timeDifference / (1000 * 60 * 60 * 24)) + 1; // Number of days between the dates
        };
    
        if (key) {
            // Check if you're asking for the starting date (ge) or ending date (le)
            if (key.includes("ge")) {
                return extractValueFromFilter(filterString, key.split(" ")[0], "ge");
            } else if (key.includes("le")) {
                return extractValueFromFilter(filterString, key.split(" ")[0], "le");
            } else if (key === 'status eq') {
                return extractStatusFromFilter(filterString);
            } else {
                return null;
            }
        } else {
            const startDate = extractValueFromFilter(filterString, 'startingDate', 'ge');
            const endDate = extractValueFromFilter(filterString, 'startingDate', 'le');
            const status = extractStatusFromFilter(filterString);
            const daysBetween = startDate && endDate ? calculateDaysBetween(startDate, endDate) : null;
    
            return {
                startDate,
                endDate,
                status,
                daysBetween
            };
        }
    }        
    function getFirstAndLastEvents(trips) {
        // Group events by partialTripId
        const groupedTrips = trips.reduce((acc, trip) => {
            if (!acc[trip.partialTripId]) {
                acc[trip.partialTripId] = [];
            }
            acc[trip.partialTripId].push(trip);
            return acc;
        }, {});
    
        // Find the first and last event for each partial trip
        const result = Object.keys(groupedTrips).map((partialTripId) => {
            const tripEvents = groupedTrips[partialTripId];
    
            // Sort events by start time
            tripEvents.sort((a, b) => new Date(a.start) - new Date(b.start));
    
            // Get the first and last event
            const resource = tripEvents[0].resource;
            const firstEvent = tripEvents[0];
            const lastEvent = tripEvents[tripEvents.length - 1];
    
            return {
                partialTripId,
                resource,
                firstEvent,
                lastEvent
            };
        });
        return result;
    } 

    function getSimplified_F_L_Events(trips) {
        // Group events by partialTripId
        const groupedTrips = trips.reduce((acc, trip) => {
            if (!acc[trip.partialTripId]) {
                acc[trip.partialTripId] = [];
            }
            acc[trip.partialTripId].push(trip);
            return acc;
        }, {});
    
        // Find the first and last event for each partial trip
        const result = Object.keys(groupedTrips).map((partialTripId) => {
            const tripEvents = groupedTrips[partialTripId];
    
            // Sort events by start time
            tripEvents.sort((a, b) => new Date(a.start) - new Date(b.start));
    
            // Get the first and last event
            const resource = tripEvents[0].resource;
            const resourceNo = tripEvents[0].resourceNo;
            const tripNo = tripEvents[0].tripNo;
            const firstDateTime = tripEvents[0]?.start;
            const lastDateTime = tripEvents[tripEvents.length - 1]?.end;
    
            return {
                resource,
                resourceNo,
                partialTripId,
                tripNo,
                firstDateTime,
                lastDateTime
            };
        });
        return result;
    } 
        
    const isEventOverlapping = (event1, event2) => {
        const start1 = new Date(event1.start);
        const end1 = new Date(event1.end);
        const start2 = new Date(event2.start);
        const end2 = new Date(event2.end);
    
        return start1 < end2 && end1 > start2;
    }
    
    // Function to check if a specific event overlaps with others
    const checkEventOverlap = (eventToCheck, allEvents) => {
        return _.filter(allEvents, (event) => {
            return event?.partialTripId === eventToCheck?.partialTripId &&
                   event?.id !== eventToCheck?.id &&  // Ensuring it's a different event
                   isEventOverlapping(eventToCheck, event);
        });
    }
    const updateEventData = (arr, id, updatedFeids) => {
        return arr.map((item)=> {
            if(item.id == id) {
                return {
                    ...item,
                    ...updatedFeids
                }
            } else {
                return item
            }
        })
    }
    return {
        initialSort,
        initialFilter,
        initialSavedViewObj,
        initialSortKeyViewObj,
        initialSavedCheckboxes,
        initialSavedDropItem,
        initialSelectedColViewObj,
        nonFilterableColumns,
        nonReorderableColumns,
        movementAggregates,
        movementColumnList,
        partialTripColumnList,
        vehicleResourceColumnList,
        driverResourceColumnList,
        routeGridColumnList,
        smovGridColumnList,
        tripColumnList,
        driverColumnList,
        subContractorColumnList,
        defaultOverlayLayers,
        planActions,
        dataActions,
        polylineColorData,
        generateTrips,
        getMapping,
        getMembers,
        processWithGroups,
        updateMovements,
        dateFormat,
        formatDateTime,
        tempFormat,
        initialViewsObj,
        convertSortToStringVal,
        setColorCodeAndDate,
        entityDefinitions,
        splitTitle,
        apiResultChecker,
        apiOKResultChecker,
        movementLinesAndOperationDeatilObject,
        movementObject,
        onMoveWindow,
        onResizeWindow,
        setWindowInitialPosition,
        existingColumns,
        getUserFilterData,
        removeUserFilterData,
        formateDate,
        getActionsIcon,
        createCustomIcon,
        routesIntersect,
        transformResourceData,
        replaceKey,
        sortEventsByTripNo,
        getConnectionColor,
        getWindowHeight,
        updateStyles,
        removeCssClass,
        showTimelines,
        removeTimelines,
        findResourceById,
        generateIconWithSelection,
        genKeyValuePair,
        parseActionResponse,
        extractCommonData,
        findEventById,
        calculateDuration,
        convertToUTCToLocal,
        findOverlappingRecord,
        findMinMaxTimes,
        parseDate,
        convertToLocalToUTC,
        generateConditionString,
        getActionIcon,
        getActionClass,
        getActionColor,
        handleFilterData,
        getFirstAndLastEvents,
        getSimplified_F_L_Events,
        findOverlappingDummyRecord,
        isEventOverlapping,
        checkEventOverlap,
        updateEventData
    };

}
export default getSetDataService 